import React from 'react';
import { useTranslation } from 'react-i18next';

import { translate } from '@translations/Translater';

import Text, { FontFamilyVariant, TextType } from '@components/Text';

import { libraryMessages } from '@containers/Library/messages';

import { ContentType } from '@presentation/Content/config';

import './styles.less';

interface IProps {
    heading?: string;
    contentType?: string | ContentType;
    navigateToListingPage?: (type: string) => void;
    children: React.ReactNode;
    isDetailsPage?: boolean;
    showSeeAll?: boolean;
}

const ContentSection = (props: IProps) => {
    const { heading, children, contentType, navigateToListingPage, isDetailsPage, showSeeAll} = props;
    const isDisplaySeeAll = contentType && !isDetailsPage && showSeeAll;

    const { t } = useTranslation();

    return (
        <div className="content_section_container">
            <div className="header">
                {!isDetailsPage && (
                    <div className="header_see_all_container">
                        {heading && <Text
                            className="group_text"
                            fontFamilyVariant={FontFamilyVariant.bold}
                            text={heading}
                            textType={TextType.h4}
                        />}
                        {isDisplaySeeAll && <div onClick={() => navigateToListingPage(contentType)}>
                            <Text
                                className="see_all"
                                fontFamilyVariant={FontFamilyVariant.regular}
                                text={translate(t, libraryMessages.seeAll)}
                                textType={TextType.subHeading1}
                            />
                        </div>}
                    </div>
                )}
            </div>
            {children}
        </div>
    );
};

export default ContentSection;

